import { render, staticRenderFns } from "./notification-PermittingExpirationSoon.vue?vue&type=template&id=5b6038d2&scoped=true"
import script from "./notification-PermittingExpirationSoon.vue?vue&type=script&lang=js"
export * from "./notification-PermittingExpirationSoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6038d2",
  null
  
)

export default component.exports